/*
If the current pathname matches ANY of these regexes (even partially), B2B redirection
will be disabled.
*/
export default [
    // Prevent redirecting from auth page, e.g. when following a Legal Rep verification link
    /\/.*-.*\/auth/,
];
